// statColumnDedup.js — DD-STAT-CONSOLIDATION carry-forward sweep (from the P0).
//
// The P0 defect class: a table renders the SAME stat field twice — once from a
// STATIC/context column block and once from the DYNAMIC (league-scoring-category)
// column set, because the two sources are never deduped at the FIELD level.
//
// These helpers give every at-risk column factory one honest place to drop the
// dynamic duplicates of the static/context stats it already renders. Prefer the
// registry's injectScoringCategories for new tables; this retrofits existing
// static+dynamic factories with the least churn.

// Simple field name from a stat config ({field:'hitting.at_bats'}) or a bare
// abbrev/field string — the last dotted segment.
export const statFieldSimple = (configOrField) => {
  const f = (configOrField && configOrField.field !== undefined) ? configOrField.field : configOrField;
  if (typeof f !== 'string') return '';
  return f.includes('.') ? f.split('.').pop() : f;
};

// Canonical simple field names of the context columns the factories hardcode.
export const STATIC_HITTING_FIELDS = ['games_played', 'at_bats', 'hits'];
export const STATIC_PITCHING_FIELDS = ['games_played', 'games_started', 'innings_pitched'];

// Drop stat configs whose underlying field duplicates a static/context column
// already emitted. `staticFields` = array/Set of simple field names.
export const excludeStaticStatConfigs = (statConfigs, staticFields) => {
  const skip = new Set(staticFields);
  return (statConfigs || []).filter((c) => !skip.has(statFieldSimple(c)));
};
